var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"style-login-v",attrs:{"justify-center":""}},[_c('v-flex',{staticStyle:{"max-width":"1000px","display":"flex","align-items":"center","justify-content":"center"},attrs:{"xs12":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }